export const CITY_NAMES = [
  'DUBAI',
  'ABU DHABI',
  'RIYADH',
  'LAHORE',
  'KARACHI',
  'ISLAMABAD',
  'RAWALPINDI',
  'MULTAN',
  'FAISALABAD',
  'DOHA',
  'DAMMAM',
  'JEDDAH',
  'DHAKA',
  'ISTANBUL',
  'KUALA LUMPUR',
  'MELBOURNE',
  'SYDNEY',
  'MUSCAT',
  'LONDON',
  'MANAMA',
  'RIFFA',
  'MUHARRAQ',
  'HAMAD TOWN',
  'BERLIN',
  'HAMBURG',
  'MUNICH',
  'COLOGNE',
  'FRANKFURT',
  'VANCOUVER',
  'TORONTO',
  'MONTREAL',
  'CALGARY',
  'DALLAS',
];

export const CITY_CENTERS = {
  dubai: { lat: 25.2048, lng: 55.2708 },
  'abu dhabi': { lat: 24.4539, lng: 54.3773 },
  riyadh: { lat: 24.7136, lng: 46.6753 },
  lahore: { lat: 31.5204, lng: 74.3587 },
  karachi: { lat: 24.8607, lng: 67.0011 },
  islamabad: { lat: 33.6844, lng: 73.0479 },
  rawalpindi: { lat: 33.5651, lng: 73.0169 },
  multan: { lat: 30.1575, lng: 71.5249 },
  faisalabad: { lat: 31.4504, lng: 73.135 },
  doha: { lat: 25.2854, lng: 51.531 },
  dammam: { lat: 26.4207, lng: 50.0888 },
  jeddah: { lat: 21.4858, lng: 39.1925 },
  dhaka: { lat: 23.8103, lng: 90.4125 },
  istanbul: { lat: 41.0082, lng: 28.9784 },
  'kuala lumpur': { lat: 3.139, lng: 101.6869 },
  melbourne: { lat: -37.8136, lng: 144.9631 },
  sydney: { lat: -33.8688, lng: 151.2093 },
  muscat: { lat: 23.588, lng: 58.3829 },
  london: { lat: 51.5074, lng: -0.1278 },
  manama: { lat: 26.2235, lng: 50.5876 },
  riffa: { lat: 26.1297, lng: 50.5554 },
  muharraq: { lat: 26.2572, lng: 50.6119 },
  'hamad town': { lat: 26.1153, lng: 50.5067 },
  berlin: { lat: 52.52, lng: 13.405 },
  hamburg: { lat: 53.5511, lng: 9.9937 },
  munich: { lat: 48.1351, lng: 11.582 },
  cologne: { lat: 50.9375, lng: 6.9603 },
  frankfurt: { lat: 50.1109, lng: 8.6821 },
  vancouver: { lat: 49.2827, lng: -123.1207 },
  toronto: { lat: 43.6532, lng: -79.3832 },
  montreal: { lat: 45.5019, lng: -73.5674 },
  calgary: { lat: 51.0447, lng: -114.0719 },
  dallas: { lat: 32.7767, lng: -96.797 },
};
